import React, { useState, useEffect } from "react";
import { Table, Card, Space, Typography } from "antd";
import { adminService } from "../../_services/admin.service";

export const CriminalAlbumLog = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCrimeCrimeAlbumAccessLogs = () => {
    setLoading(true);
    adminService
      .getCrimeCrimeAlbumAccessLogs()
      .then((res) => {
        setData(res.data || []);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getCrimeCrimeAlbumAccessLogs();
  }, []);

  const columns = [
    {
      title: "Sr No",
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: "Album ID",
      dataIndex: "album_id",
      key: "album_id",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      key: "ip_address",
    },
    {
      title: "Browser Info",
      dataIndex: "browser_info",
      key: "browser_info",
    },
    {
      title: "OS Info",
      dataIndex: "os_info",
      key: "os_info",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Date",
      dataIndex: "accessed_at",
      key: "accessed_at",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.accessed_at
            ? new Date(record.accessed_at.replace(" ", "T")).toLocaleString(
                "en-IN",
                {
                  timeZone: "Asia/Kolkata",
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }
              )
            : "-"}
        </Space>
      ),
    },
  ];

  return (
    <>
      <Card title="Criminal Album Logs">
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          rowKey={(record) => record.id}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </>
  );
};
